import { Checkbox } from "@alm/flow-ds/components";
import { setFormFullWidth } from "data/app/appActions";
import { FormLayout } from "hooks/FormDesigner/useElementList";
import React, { useCallback } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

interface Props {
	fullWidth: FormLayout["fullWidth"];
	updateFormLayoutFullWidth: (data: boolean) => void;
}

const ExpandedLayout = ({ fullWidth, updateFormLayoutFullWidth }: Props) => {
	const [expandedLayout, setExpandedLayout] = useState<boolean>(
		fullWidth || false
	);

	const { t } = useTranslation();
	const reduxDispatch = useDispatch();

	const handleChange = useCallback(() => {
		setExpandedLayout(!expandedLayout);
		updateFormLayoutFullWidth(!expandedLayout);
		reduxDispatch(setFormFullWidth(!expandedLayout));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [expandedLayout, updateFormLayoutFullWidth]);

	return (
		<Checkbox
			id="expanded-layout"
			label={t("formDesigner.labels.expandedLayout")}
			onChange={handleChange}
			value={expandedLayout.toString()}
			checked={expandedLayout}
		/>
	);
};

export default ExpandedLayout;
